// src/store/useAppStore.js
import { create } from "zustand";

const useAppStore = create((set) => ({
  // ── Sidebar ──
  sidebarOpen: window.innerWidth >= 768,
  setSidebarOpen: (val) => set({ sidebarOpen: val }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),

  // ── Store info ──
  storeName: "",
  setStoreName: (name) => set({ storeName: name }),

  // ── Product row selection ──
  selectedIds: new Set(),
  toggleSelect: (id) =>
    set((s) => {
      const next = new Set(s.selectedIds);
      next.has(id) ? next.delete(id) : next.add(id);
      return { selectedIds: next };
    }),
  selectAll: (ids) => set({ selectedIds: new Set(ids) }),
  clearSelection: () => set({ selectedIds: new Set() }),
}));

export default useAppStore;